// src/components/OrderActionButtons.js
import React, { useState } from "react";
import {
  Box,
  Grid,
  FormControl,
  Tooltip,
  IconButton,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  useTheme,
  Divider,
} from "@mui/material";

// Import your icons

import CancelIcon from "@mui/icons-material/Cancel";
import Approveicon from "@mui/icons-material/CheckCircle";
import Amendicon from "@mui/icons-material/Edit";
import Printicon from "@mui/icons-material/Print";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import Close from '@mui/icons-material/Close';

const OrderActionButtons = ({
  // visibility toggles
  btnAdditionalDetailshow,
  btnSaveUpdateOrdershow,
  btnCancel,
  btnApproveOrdershow,
  btnAmendmentshow,
  btnPrint,

  // labels
  btnSaveOrderText = "Save",

  // handlers
  openOrderAdditionalData,
  handleOrdersSubmit,
  handleShowCancelConfirmation,
  handleCloseCancelConfirmation,
  openOrderCancel,
  openCancelConfirmation,

  handleShowApproveConfirmation,
  handleCloseApproveConfirmation,
  handleApproveOrdersSubmit,
  openApproveConfirmation,

  handleShowAmendmentConfirmation,
  handleCloseAmendmentConfirmation,
  AmendmentofOrder,
  openAmendmentConfirmation,

  handleViewReport,
  title,
  callback,
}) => {
  
  const theme = useTheme();
  const [selectedButton, setSelectedButton] = useState(null);

  const handleButtonClick = (buttonName) => {
    setSelectedButton(buttonName);

    if (buttonName === 'cancel') {
      handleShowCancelConfirmation();
    }
    else if (buttonName === 'approve') {
      handleShowApproveConfirmation();

    }
    else if (buttonName === 'ament') {
      handleShowAmendmentConfirmation();
    }
    else if (buttonName === 'save') {
      handleOrdersSubmit();
    }
    else if (buttonName === 'Print') {
      handleViewReport();
    }

  };

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Grid container justifyContent="space-between" alignItems="center" padding={0}>

        {/* Left-aligned: Edit Employee */}
        <Grid item>
          <Typography variant="h4" sx={{ textAlign: "center", width: "100%", marginLeft: "10px", alignItems: "center" }}>
            {/* {title === 0 ? 'New Employee' : 'Edit Employee'} */}
            {title}
            {/* New Order */}
          </Typography>
        </Grid>
        <Grid item>
          <Grid container alignItems="center">
            {btnSaveUpdateOrdershow && (
              <>
                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                {/* Save */}
                <Grid item ml={1} mr={1}>
                  <Tooltip title={btnSaveOrderText}>
                    <IconButton
                      onClick={() => handleButtonClick('save')}
                      sx={{ display: 'flex', alignItems: 'center' }}
                    
                    // disabled={saveButtonDisabled}
                    >
                      <SaveAltIcon style={{ fontSize: "18px", color: selectedButton === 'save' ? "yellow" : "#009688" }} />
                      <Typography variant="body2" sx={{ ml: 1 }}>Save</Typography>
                    </IconButton>
                  </Tooltip>
                </Grid>
              </>
            )}
            <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />



            {btnCancel && (
              <>

                {/* cancel */}
                <Grid item ml={1} mr={1}>
                  <Tooltip title="Cancel Order">
                    <IconButton
                      onClick={() => handleButtonClick('cancel')}
                      sx={{ display: 'flex', alignItems: 'center' }}
                    // type="submit"
                    // disabled={saveButtonDisabled}
                    >
                      <CancelIcon style={{ fontSize: "18px", color: selectedButton === 'save' ? "yellow" : "#009688" }} />
                      <Typography variant="body2" sx={{ ml: 1 }}>Cancel</Typography>
                    </IconButton>
                  </Tooltip>

                  <Dialog
                    open={openCancelConfirmation}
                    onClose={handleCloseCancelConfirmation}
                  >
                    <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>
                      Cancel Order
                    </DialogTitle>
                    <DialogContent style={{ backgroundColor: theme.palette.background.default }}>
                      <DialogContentText>
                        Are you sure want to Cancel this Order?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ backgroundColor: theme.palette.background.default }}>
                      <Button
                        variant="contained"
                        style={{ fontWeight: "bold", color: "#26a69a" }}
                        onClick={openOrderCancel}
                      >
                        Yes
                      </Button>
                      <Button
                        variant="contained"
                        style={{ fontWeight: "bold", color: "#26a69a" }}
                        onClick={handleCloseCancelConfirmation}
                      >
                        No
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Grid>
                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
              </>
            )}

            {btnApproveOrdershow && (
              <>

                {/* cancel */}
                <Grid item ml={1} mr={1}>
                  <Tooltip title="Approve Order">
                    <IconButton
                      onClick={() => handleButtonClick('approve')}
                      sx={{ display: 'flex', alignItems: 'center' }}
                    // type="submit"
                    // disabled={saveButtonDisabled}
                    >
                      <Approveicon style={{ fontSize: "18px", color: selectedButton === 'save' ? "yellow" : "#009688" }} />
                      <Typography variant="body2" sx={{ ml: 1 }}>Approve</Typography>
                    </IconButton>
                  </Tooltip>
                  
                  <Dialog
                    open={openApproveConfirmation}
                    onClose={handleCloseApproveConfirmation}
                  >
                    <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>
                      Approve Order
                    </DialogTitle>
                    <DialogContent style={{ backgroundColor: theme.palette.background.default }}>
                      <DialogContentText>
                        This will approve the Order. Would you like to continue?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ backgroundColor: theme.palette.background.default }}>
                      <Button
                        variant="contained"
                        style={{ fontWeight: "bold", color: "#26a69a" }}
                        onClick={handleApproveOrdersSubmit}
                      >
                        Yes
                      </Button>
                      <Button
                        variant="contained"
                        style={{ fontWeight: "bold", color: "#26a69a" }}
                        onClick={handleCloseApproveConfirmation}
                      >
                        No
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Grid>
                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />


              </>
            )}

            {btnAmendmentshow && (
              <>

                {/* cancel */}
                <Grid item ml={1} mr={1}>
                  <Tooltip title="Amend the Order">
                    <IconButton
                      onClick={() => handleButtonClick('ament')}
                      sx={{ display: 'flex', alignItems: 'center' }}
                      // type="submit"
                    // disabled={saveButtonDisabled}
                    >
                      <Amendicon style={{ fontSize: "18px", color: selectedButton === 'save' ? "yellow" : "#009688" }} />
                      <Typography variant="body2" sx={{ ml: 1 }}>Ament</Typography>
                    </IconButton>
                  </Tooltip>

                  <Dialog
                    open={openAmendmentConfirmation}
                    onClose={handleCloseAmendmentConfirmation}
                  >
                    <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>
                      Amend Order
                    </DialogTitle>
                    <DialogContent style={{ backgroundColor: theme.palette.background.default }}>
                      <DialogContentText>
                        This will allow amendment of the Order. Would you like to continue?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ backgroundColor: theme.palette.background.default }}>
                      <Button
                        variant="contained"
                        style={{ fontWeight: "bold", color: "#26a69a" }}
                        onClick={AmendmentofOrder}
                      >
                        Yes
                      </Button>
                      <Button
                        variant="contained"
                        style={{ fontWeight: "bold", color: "#26a69a" }}
                        onClick={handleCloseAmendmentConfirmation}
                      >
                        No
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Grid>
                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
              </>
            )}

            {btnPrint && (
              <>

                {/* cancel */}
                <Grid item ml={1} mr={1}>
                  <Tooltip title="Print">
                    <IconButton
                      onClick={() => handleButtonClick('Print')}
                      sx={{ display: 'flex', alignItems: 'center' }}
                    // type="submit"
                    // disabled={saveButtonDisabled}
                    >
                      <Printicon style={{ fontSize: "18px", color: selectedButton === 'save' ? "yellow" : "#009688" }} />
                      <Typography variant="body2" sx={{ ml: 1 }}>Print</Typography>
                    </IconButton>
                  </Tooltip>
                </Grid>
                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
              </>
            )}



            <IconButton onClick={callback}>
              <Close style={{ fontSize: "14px", color: "#2196F3" }} />
            </IconButton>
            <Divider orientation="vertical" flexItem
            // sx={{ mx: 1 }} 
            />
          </Grid>
        </Grid>


        {/* {btnAdditionalDetailshow && (
          <Grid item md={0} mr={1}>
            <FormControl fullWidth>
              <Tooltip title="Additional Details">
                <IconButton onClick={openOrderAdditionalData}>
                  <AdditionalIcon style={{ color: "#9e9d24" }} />
                </IconButton>
              </Tooltip>
              <Typography align="center" fontSize={11}>
                Additional
              </Typography>
            </FormControl>
          </Grid>
        )} */}

        {/* {btnSaveUpdateOrdershow && (
          <Grid item md={0} mr={1}>
            <FormControl fullWidth>
              <Tooltip title={btnSaveOrderText}>
                <IconButton onClick={handleOrdersSubmit}>
                  <Saveicon style={{ color: "#388e3c" }} />
                </IconButton>
              </Tooltip>
              <Typography align="center" fontSize={11}>
                Save
              </Typography>
            </FormControl>
          </Grid>
        )} */}

        {/* {btnCancel && (
          <Grid item md={0} mr={1}>
            <FormControl fullWidth>
              <Tooltip title="Cancel Order">
                <IconButton
                  onClick={handleShowCancelConfirmation}
                  style={{ color: "#ef5350" }}
                >
                  <CancelIcon />
                </IconButton>
              </Tooltip>
              <Typography align="center" fontSize={11}>
                Cancel
              </Typography>
            </FormControl>

            <Dialog
              open={openCancelConfirmation}
              onClose={handleCloseCancelConfirmation}
            >
              <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>
                Cancel Order
              </DialogTitle>
              <DialogContent style={{ backgroundColor: theme.palette.background.default }}>
                <DialogContentText>
                  Are you sure want to Cancel this Order?
                </DialogContentText>
              </DialogContent>
              <DialogActions style={{ backgroundColor: theme.palette.background.default }}>
                <Button
                  variant="contained"
                  style={{ fontWeight: "bold", color: "#26a69a" }}
                  onClick={openOrderCancel}
                >
                  Yes
                </Button>
                <Button
                  variant="contained"
                  style={{ fontWeight: "bold", color: "#26a69a" }}
                  onClick={handleCloseCancelConfirmation}
                >
                  No
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        )}

        {btnApproveOrdershow && (
          <Grid item md={0} mr={1}>
            <FormControl fullWidth>
              <Tooltip title="Approve Order">
                <IconButton
                  onClick={handleShowApproveConfirmation}
                  style={{ color: "#26a69a" }}
                >
                  <Approveicon />
                </IconButton>
              </Tooltip>
              <Typography align="center" fontSize={11}>
                Approve
              </Typography>
            </FormControl>

            <Dialog
              open={openApproveConfirmation}
              onClose={handleCloseApproveConfirmation}
            >
              <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>
                Approve Order
              </DialogTitle>
              <DialogContent style={{ backgroundColor: theme.palette.background.default }}>
                <DialogContentText>
                  This will approve the Order. Would you like to continue?
                </DialogContentText>
              </DialogContent>
              <DialogActions style={{ backgroundColor: theme.palette.background.default }}>
                <Button
                  variant="contained"
                  style={{ fontWeight: "bold", color: "#26a69a" }}
                  onClick={handleApproveOrdersSubmit}
                >
                  Yes
                </Button>
                <Button
                  variant="contained"
                  style={{ fontWeight: "bold", color: "#26a69a" }}
                  onClick={handleCloseApproveConfirmation}
                >
                  No
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        )}

        {btnAmendmentshow && (
          <Grid item md={0} mr={1}>
            <FormControl fullWidth>
              <Tooltip title="Amend the Order">
                <IconButton
                  onClick={handleShowAmendmentConfirmation}
                  style={{ color: "#f06292" }}
                >
                  <Amendicon />
                </IconButton>
              </Tooltip>
              <Typography align="center" fontSize={11}>
                Amend
              </Typography>
            </FormControl>

            <Dialog
              open={openAmendmentConfirmation}
              onClose={handleCloseAmendmentConfirmation}
            >
              <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>
                Amend Order
              </DialogTitle>
              <DialogContent style={{ backgroundColor: theme.palette.background.default }}>
                <DialogContentText>
                  This will allow amendment of the Order. Would you like to continue?
                </DialogContentText>
              </DialogContent>
              <DialogActions style={{ backgroundColor: theme.palette.background.default }}>
                <Button
                  variant="contained"
                  style={{ fontWeight: "bold", color: "#26a69a" }}
                  onClick={AmendmentofOrder}
                >
                  Yes
                </Button>
                <Button
                  variant="contained"
                  style={{ fontWeight: "bold", color: "#26a69a" }}
                  onClick={handleCloseAmendmentConfirmation}
                >
                  No
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        )}

        {btnPrint && (
          <Grid item md={0} mr={1}>
            <FormControl fullWidth>
              <Tooltip title="Print">
                <IconButton
                  onClick={handleViewReport}
                  style={{ color: "#689f38" }}
                >
                  <Printicon />
                </IconButton>
              </Tooltip>
              <Typography align="center" fontSize={11}>
                Print
              </Typography>
            </FormControl>
          </Grid>
        )} */}
      </Grid>
    </Box>
  );
};

export default OrderActionButtons;
